export const TableIcon = ({ iconUrl }: { iconUrl: string }) => (
  <div className="flex items-center justify-center rounded-sm border-2 p-1 w-10 h-10 bg-foreground mr-2">
    <img src={iconUrl} className="h-inherit max-h-6 max-w-6 w-inherit" />
  </div>
)
